import http from '@/api/base'

let str = '/dcits-workflow'
// 新版根据ID查询待“收款确认”列表
const invoiceConfirmListV2 = (params) => {
  params.platformFlag = true
  return http.post(str + '/charge-bill/invoice-list/v2', params)
}

const queryInvoiceDetail = (params) => {
  params.platformFlag = true
  return http.post(str + '/charge-bill/queryInvoiceDetail', params)
}

// 检查开票确认，开票流程发起之前
const checkInvoice = (params) => {
  params.platformFlag = true
  return http.post(str + '/charge-bill/checkInvoice', params)
}

export default {
  invoiceConfirmListV2,
  queryInvoiceDetail,
  checkInvoice

}



// WEBPACK FOOTER //
// ./src/area-dcits/api/invoicesWorkflow.js